import LocationAlertHomeIcon from '@op/assets/onboarding/places-home.svg'
import LocationAlertParkIcon from '@op/assets/onboarding/places-school.svg'
import ScheduleBedIcon from '@op/assets/onboarding/schedule-bedtime.svg'
import ScheduleHomeIcon from '@op/assets/onboarding/schedule-homework.svg'
import ScheduleSchoolIcon from '@op/assets/onboarding/schedule-school.svg'
import type { CssGlyphName } from '@op/icons'
import type { GranType } from '@op/services'
import type { OnboardingPageName } from '../../types'

// TODO: all of this is reused in both web/mobile onboarding, bring them out to a common file

export const ONBOARDING_PAGE_CONCERNS = 'concerns' satisfies OnboardingPageName
export const ONBOARDING_PAGE_CHILDREN = 'children' satisfies OnboardingPageName
export const ONBOARDING_PAGE_LOADING = 'loading' satisfies OnboardingPageName
export const ONBOARDING_PAGE_SUMMARY = 'summary' satisfies OnboardingPageName

export const ONBOARDING_PAGES: OnboardingPageName[] = [
	ONBOARDING_PAGE_CONCERNS,
	ONBOARDING_PAGE_CHILDREN,
	ONBOARDING_PAGE_LOADING,
	ONBOARDING_PAGE_SUMMARY,
]

export const PROFILE_SETUP_STEPS = [
	'Analyzing age-appropriate settings',
	'Configuring app restrictions',
	'Setting up screen time limits',
	'Enabling content monitoring',
]

export const PROFILE_SETUP_LOADING_MESSAGES = [
	'Setting up profiles...',
	'Configuring parental controls...',
	'Optimizing settings for your children...',
	'Finalizing protection rules...',
	'Almost ready...',
]

export const PROFILE_SETUP_LOW_DURATION = 2800
export const PROFILE_SETUP_HIGH_DURATION = 5000

// TODO: all of this is reused in both web/mobile onboarding, bring them out to a common file
export const APP_RULE_STATUS_ICON_MAP = {
	A: 'check-circle',
	N: 'cancel',
	S: 'clock',
} satisfies { readonly [K in GranType]: CssGlyphName }

export const getRuleStatusColorMap = {
	A: 'text-green',
	N: 'text-red',
	S: 'text-teal',
} satisfies { readonly [K in GranType]: string }

export const APP_RULE_STATUS_TEXT_MAP = {
	A: 'Always Allowed',
	N: 'Blocked',
	S: 'Screen Time Rules',
} satisfies { readonly [K in GranType]: string }

export const LOCATION_ALERT_ICON_MAP = new Map<string, string>([
	['gf_home', LocationAlertHomeIcon],
	['gf_school', LocationAlertParkIcon],
])

export const SCHEDULE_ICON_MAP = new Map<string, string>([
	['sc_bedtime', ScheduleBedIcon],
	['sc_school', ScheduleSchoolIcon],
	['sc_homework', ScheduleHomeIcon],
])

export const VEW_STATUS_TEXT_MAP = new Map<string, string>([
	['vi_detect_inappropriate_content', 'On'],
	['vi_mental_health', 'Added'],
])
